import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const cysticFibrosis: AnswerPathTreeNode = {
  path: 'cysticFibrosis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCysticFibrosisDetails }],
};
